








































































































































































import Vue from "vue";
import Component from "vue-class-component";
import FactFindAssets from "./FactFindAssets.vue";
import FactFindDetails from "./FactFindDetails.vue";
import FactFindDependants from "./FactFindDependants.vue";
import FactFindEmployments from "./FactFindEmployments.vue";
import FactFindExpenses from "./FactFindExpenses.vue";
import FactFindIncomes from "./FactFindIncomes.vue";
import FactFindPensions from "./FactFindPensions.vue";
import FactFindPolicies from "./FactFindPolicies.vue";
import FactFindLiabilityCard from "./FactFindLiabilityCard.vue";
import FactFindLiabilityLoan from "./FactFindLiabilityLoan.vue";
import FactFindLiabilityMortgage from "./FactFindLiabilityMortgage.vue";
import FactFindLiabilityOther from "./FactFindLiabilityOther.vue";
import FactFindComplete from "./FactFindComplete.vue";
import BackButton from "@/components/BackButton.vue";
import ApiFactory from "../../api/ApiFactory";
import AlertService from "@/services/alert.service";
import FactFindPartnerDetails from "./FactFindPartnerDetails.vue";
import router, { ROUTES } from "@/router";
import { UserStore, LoadingSpinnerService, RoleStore } from "../../store";
import { RoleStoreModule } from "../../store/users/role.store";
import {
  FindFactFindRequestByContactQuery,
  FactFindRequestDto,
  FactFindEmployment
} from "@/api/ClientPortalApiClient";

@Component({
  components: {
    FactFindComplete,
    FactFindAssets,
    FactFindDetails,
    FactFindDependants,
    FactFindEmployments,
    FactFindExpenses,
    FactFindIncomes,
    FactFindPensions,
    FactFindLiabilityCard,
    FactFindLiabilityLoan,
    FactFindLiabilityOther,
    FactFindLiabilityMortgage,
    FactFindPartnerDetails,
    FactFindPolicies,
    BackButton
  }
})
export default class FactFindMain extends Vue {
  private sections = [
    { name: "Your Details", code: "default", icon: "user" },
    { name: "Partner Details", code: "partner", icon: "user-plus" },
    { name: "Dependants", code: "dependants", icon: "baby" },
    { name: "Employments", code: "employments", icon: "briefcase" },
    { name: "Incomes", code: "incomes", icon: "wallet" },
    { name: "Assets", code: "assets", icon: "car" },
    { name: "Pensions", code: "pensions", icon: "piggy-bank" },
    { name: "Protection", code: "policies", icon: "umbrella" },
    { name: "Expenses", code: "expenses", icon: "file-invoice" },
    { name: "Credit Cards", code: "cards", icon: "credit-card" },
    { name: "Loans", code: "loans", icon: "university" },
    { name: "Mortgages", code: "mortgages", icon: "home" },
    { name: "Other Liabilities", code: "others", icon: "money-bill-wave-alt" }
  ];
  private mode = "default";
  private isFactFindCompleted: boolean = false;
  private alertService = new AlertService();
  private modalSubmitTitle: string = "modal-submit-factfind";
  isAdvisor: boolean = RoleStore.isAnAdvisor;
  contactId: number = 0;
  fullName: string = "";

  $refs!: {
    default: FactFindDetails;
    assets: FactFindAssets;
    incomes: FactFindIncomes;
    pensions: FactFindPensions;
    protection: FactFindPolicies;
    expenses: FactFindExpenses;
    cards: FactFindLiabilityCard;
    loans: FactFindLiabilityLoan;
    mortgages: FactFindLiabilityMortgage;
    others: FactFindLiabilityOther;
    dependants: FactFindDependants;
    employments: FactFindEmployments;
    partner: FactFindPartnerDetails;
  };

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    if (RoleStore.isClient) {
      await this.checkIsCompleted();
    }
  }

  private async checkIsCompleted() {
    const api = ApiFactory.CreateDataClient();
    const profile = await api.profile_getByContactId(
      this.contactId || UserStore.profileId
    );
    this.fullName = `${profile.firstName} ${profile.lastName}`;
    const result = await api.factFindRequest_IsCompleted(this.contactId);
    const hasRole = RoleStore.isFactFindUser || this.isAdvisor;

    if (result || !hasRole) {
      router.push({ name: ROUTES.home });
    }
  }

  submit() {
    this.$bvModal.show(this.modalSubmitTitle);
  }

  private async submitConfirmed() {
    LoadingSpinnerService.Show("Submitting your Fact Find...");
    const api = ApiFactory.CreateDataClient();
    try {
      const result = await api.factFindRequest_Complete();
      if (result) {
        LoadingSpinnerService.Success(
          "Your Fact Find has been submitted successfully."
        );
        setTimeout(() => {
          this.isFactFindCompleted = true;
          this.$router.push({ name: ROUTES.home });
        }, 2000);
      } else {
        this.isFactFindCompleted = false;
        LoadingSpinnerService.Failure(
          "Unable to submit your Fact Find. Please try again."
        );
      }
    } catch (e) {
      this.isFactFindCompleted = false;
      LoadingSpinnerService.Failure(
        "Unable to submit your Fact Find. Please try again."
      );
    }
    this.$bvModal.hide(this.modalSubmitTitle);
  }

  private async changeMode(code: string) {
    if (await this.checkForChange()) this.mode = code;
  }

  private async checkForChange(): Promise<boolean> {
    switch (this.mode) {
      case "assets":
        return await this.$refs.assets.checkForChanges();
      case "incomes":
        return await this.$refs.incomes.checkForChanges();
      case "pensions":
        return await this.$refs.pensions.checkForChanges();
      case "policies":
        return await this.$refs.protection.checkForChanges();
      case "expenses":
        return await this.$refs.expenses.checkForChanges();
      case "cards":
        return await this.$refs.cards.checkForChanges();
      case "loans":
        return await this.$refs.loans.checkForChanges();
      case "mortgages":
        return await this.$refs.mortgages.checkForChanges();
      case "others":
        return await this.$refs.others.checkForChanges();
      case "dependants":
        return await this.$refs.dependants.checkForChanges();
      case "employments":
        return await this.$refs.employments.checkForChanges();
      case "partner":
        return await this.$refs.partner.checkForChanges();
      case "default":
        return await this.$refs.default.checkForChanges();
    }

    return false;
  }

  submitCancelled() {
    this.$bvModal.hide(this.modalSubmitTitle);
  }

  private async nextPage() {
    const idx = this.sections.findIndex(x => x.code === this.mode);

    if (await this.checkForChange()) {
      try {
        this.mode = this.sections[idx + 1].code;
      } catch (e) {
        this.mode = this.sections[0].code;
      }
    }
  }

  get clientFullName(): string {
    return this.fullName || UserStore.clientFullName;
  }
}
